export default __webpack_public_path__ + "static/media/1280.846ae359.png";